export default {
    darkBlue: "var(--primary-blue)",
    lightBlue: "#52B3D8",
    lightBlueHover: "#3FA6CD",
    blue700: "var(--blue-700)",
    green: "#9BC940",
    red: "#D43D60",
    lightGray: "#F1F3F5",
    white: "#ffffff",
    black: "#000000",
}